import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import {
  Redirect,
  Switch,
  withRouter
} from 'react-router-dom'
import CONSTANTS from '../../constants'
import { slugify, formattedAdress } from '../../helpers/functions'
import './search-area.css'
import Autocomplete from 'react-google-autocomplete'
import {
  setSelectedLat,
  setSelectedLong,
  setFilterDealersBy,
  setFilterByChoice,
  setListPremiumServicesToStore
} from '../../actions/action';
import ServicesFilter from './Services-filter/services-filter'
import fetchApiData from '../apiHandlers/fetchApiData'
const google = window.google

const mapStateToProps = state => state;
const mapDispatchToProps = {
  setSelectedLat,
  setSelectedLong,
  setFilterDealersBy,
  setFilterByChoice,
  setListPremiumServicesToStore
};



class SearchArea extends PureComponent {
  constructor(props) {
    super(props)
    this.adressSearchInput = React.createRef()
    this.getGeoAdressFromSearchInput = this.getGeoAdressFromSearchInput.bind(this)
    this.state = {
      filterBy: this.props.store.filterDealersBy,
      listPremiumServices: props.store.listPremiumServices || [],
      showFilter: false,
      goToSelectDealer: false,
      selectedAdress: {
        adress: '',
        lat: null,
        lng: null
      },
      // isClassOpen: "hidden"
    }
  }

  componentDidMount() {
    this.adressSearchInput.current.refs.input.setAttribute('autocomplete', 'on')
    if (this.props.match.params.adress) {
      this.setState({
        selectedAdress: {
          adress: this.props.match.params.adress.replace(/-/g, ' '),
          lat: null,
          lng: null
        }
      })
    }

    if (typeof this.state.listPremiumServices != undefined) {
      this.state.listPremiumServices.length < 1
        ? this.handleGetPremiumServices()
        : this.setState({ showFilter: this.state.listPremiumServices.some(service => service.displayDL) })
    }
  }

  getGeoAdressFromSearchInput(inputRef) {
    console.log(inputRef.current.refs.input.value)
    if (inputRef) {
      const geocoder = new google.maps.Geocoder()
      console.log(inputRef.current.refs.input.value)
      geocoder.geocode({
        address: inputRef.current.refs.input.value,
        componentRestrictions: {
          country: window.siteConfig.currentCountry
        }
      }, (results, status) => {
        if (status === 'OK') {
          console.log(results)

          if (results[0]) {
            console.log(results[0].formatted_address)
            this.setState(prevState => ({
              selectedAdress: {
                ...prevState.selectedAdress.adress,
                adress: results[0].formatted_address,
                lat: results[0].geometry.location.lat(),
                lng: results[0].geometry.location.lng()
              },
              goToSelectDealer: true
            }));

            this.props.setSelectedLat(results[0].geometry.location.lat());
            this.props.setSelectedLong(results[0].geometry.location.lng());
          } else {
            console.log('No results found')
          }
        } else {
          console.log('Geocoder failed due to: ' + status)
        }
      })

      // event label remonte les données renseignées lors de la recherche
      window.dataLayer.push({
        pageName: (this.props.store.step == 1 ? 'dealer locator' : 'multicréneaux'),
        event: 'uaevent',
        eventCategory: 'Dealerlocator',
        eventAction: (this.props.store.step == 1 ? 'Redirection::Search::Dealer' : 'Redirection::Search::NewDealer'),
        eventLabel: this.state.selectedAdress.adress
      })

      if (this.state.selectedAdress.lat != null) { this.setState({ goToSelectDealer: true }) }
    }
  }

  // to avoid redirection to the same route
  componentWillUpdate(nextProps, nextState) {
    if (nextState.goToSelectDealer) { this.setState({ goToSelectDealer: false }) }
  }

  handleGetPremiumServices = () => {
    const fetchApi = new fetchApiData()
    fetchApi.getServicePremium()
      .then(
        data => {
          this.setState({ showFilter: data.d.some(service => service.displayDL) })
          this.setState({ listPremiumServices: data.d })
          this.props.setListPremiumServicesToStore(data.d)
        })
      .catch(error => {
        console.error(error)
      })
  }
  // add or remove premium service from the filter 
  handleAddOrRemoveToFilter = (premiumServiceId, isChecked) => {
    isChecked ? this.setState({ filterBy: [...this.state.filterBy, premiumServiceId] }) : this.setState({ filterBy: this.state.filterBy.filter(item => item !== premiumServiceId) })
  }

  // appliquer les filtres les services premium cocher 
  handleApplyFilter = () => {
    this.props.setFilterDealersBy(this.state.filterBy)
  }

  render() {

    return (
      <div className='search-area'>
        {this.state.goToSelectDealer && <Switch>
          <Redirect
            push
            to={{ pathname: `${CONSTANTS.SITE_ROUTS.LISTDEALERSPAGE}/${slugify(formattedAdress(this.state.selectedAdress.adress))}` }}
          />
        </Switch>}

        {CONSTANTS.SITE_INFO.BRAND_CODE !== "C" && <p tabIndex="0" className='label-search' dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.dealer_locator_subtitle) }}></p>}

        <div className='search-field'>

          <div className='form-container fields-form'>
            {window.isMobile() === 'desktop' && this.state.showFilter &&
              <ServicesFilter
                selectedPremiumServices={this.props.store.filterDealersBy}
                listPremiumServices={this.state.listPremiumServices}
                onAddOrRemoveToFilter={this.handleAddOrRemoveToFilter}
                onApplyFilter={this.handleApplyFilter}
              />
            }

            <div className='field-content'>
              {/* <form autoComplete='off'> */}
              <Autocomplete
                aria-label={CONSTANTS.LABELS.dealer_locator_searchlabel}
                placeholder={CONSTANTS.LABELS.dealer_locator_searchlabel}
                className='form-elements form--input-text'
                onChange={(e) => this.setState({
                  selectedAdress: {
                    adress: e.target.value
                  }
                })}
                onKeyPress={e => {
                  console.log(this.adressSearchInput)
                  console.log(e.target.value)
                  if (e.key === 'Enter') this.getGeoAdressFromSearchInput(this.adressSearchInput)
                }}
                ref={this.adressSearchInput}
                value={this.state.selectedAdress.adress}
                onPlaceSelected={(place) => {
                  console.log(place)
                  if (place.hasOwnProperty('place_id')) {
                    this.setState({
                      selectedAdress: {
                        adress: place.formatted_address,
                        lat: place.geometry.location.lat(),
                        lng: place.geometry.location.lng()
                      }
                    })
                  }
                }}
                types={['geocode']}
                componentRestrictions={{ country: window.siteConfig.currentCountry }}
              />
              {/* </form> */}
              {/* {CONSTANTS.SITE_INFO.BRAND_CODE == 'C' && <svg xmlns='http://www.w3.org/2000/svg' aria-hidden="true" viewBox='0 0 18.484 18.427' className='search-icon'>
                <defs>
                  <style dangerouslySetInnerHTML={{
                    __html: `
                                    .cls-1,
                .cls-3 {
                fill: none;
                }
                .cls-1 {
                stroke: #fff;
                stroke-width: 2px;
                }
                .cls-2 {
                stroke: none;
                }
                                    `
                  }}
                  />

                </defs>
                <g id='search-icon' transform='translate(-90.824 -1477.62)'>
                  <g id='Ellipse_86' data-name='Ellipse 86' className='cls-1' transform='translate(90.824 1485.83) rotate(-43)'>
                    <ellipse className='cls-2' cx='6.019' cy='6.019' rx='6.019' ry='6.019' />
                    <ellipse className='cls-3' cx='6.019' cy='6.019' rx='5.019' ry='5.019' />
                  </g>
                  <path id='loop-hand' data-name='Tracé 977' className='cls-1' d='M-339.5-1339.645v-8.08' transform='translate(1270.507 2243.582) rotate(-43)' />
                </g>
              </svg>} */}
            </div>
            <button
              type='button' className='search-button'
              onClick={
                () => this.getGeoAdressFromSearchInput(this.adressSearchInput)
              }
            >
              <svg xmlns='http://www.w3.org/2000/svg' aria-hidden="true" viewBox='0 0 18.484 18.427' className='search-icon'>
                <defs>
                  <style dangerouslySetInnerHTML={{
                    __html: `
                                    .cls-1,
                .cls-3 {
                fill: none;
                }
                .cls-1 {
                stroke: #fff;
                stroke-width: 2px;
                }
                .cls-2 {
                stroke: none;
                }
                                    `
                  }}
                  />

                </defs>
                <g id='search-icon' transform='translate(-90.824 -1477.62)'>
                  <g id='Ellipse_86' data-name='Ellipse 86' className='cls-1' transform='translate(90.824 1485.83) rotate(-43)'>
                    <ellipse className='cls-2' cx='6.019' cy='6.019' rx='6.019' ry='6.019' />
                    <ellipse className='cls-3' cx='6.019' cy='6.019' rx='5.019' ry='5.019' />
                  </g>
                  <path id='loop-hand' data-name='Tracé 977' className='cls-1' d='M-339.5-1339.645v-8.08' transform='translate(1270.507 2243.582) rotate(-43)' />
                </g>
              </svg>
              <span>
                {CONSTANTS.LABELS.dealer_locator_searchcta}
              </span>
            </button>
          </div>
        </div>
        {window.isMobile() === 'mobile' && this.state.showFilter &&
          <ServicesFilter
            selectedPremiumServices={this.props.store.filterDealersBy}
            onAddOrRemoveToFilter={this.handleAddOrRemoveToFilter}
            listPremiumServices={this.state.listPremiumServices}
            onApplyFilter={this.handleApplyFilter}
          />
        }
      </div>
    )
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SearchArea))
